import { Decoration_Type } from "./../ricos-types/index.js";
const TEXT_COLOR_MODAL_ID = `${Decoration_Type.COLOR}.foreground.picker`;
const TEXT_HIGHLIGHT_MODAL_ID = `${Decoration_Type.COLOR}.background.picker`;
export {
  TEXT_COLOR_MODAL_ID,
  TEXT_HIGHLIGHT_MODAL_ID
};
//# sourceMappingURL=constants.js.map
